function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React$1, { useState, useCallback } from 'react';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { classNames, variationName } from '../../utilities/css.js';
import { SelectMinor, CaretUpMinor, CaretDownMinor } from '@shopify/polaris-icons';
import { handleMouseUpByBlurring } from '../../utilities/focus.js';
import { Icon as Icon$1 } from '../Icon/Icon.js';
import { Spinner as Spinner$1 } from '../Spinner/Spinner.js';
import { Popover as Popover$1 } from '../Popover/Popover.js';
import { ActionList as ActionList$1 } from '../ActionList/ActionList.js';
import { UnstyledButton as UnstyledButton$1 } from '../UnstyledButton/UnstyledButton.js';
import styles from './Button.scss.js';
var DEFAULT_SIZE = 'medium';

var _ref = /*#__PURE__*/React$1.createElement(Icon$1, {
  source: CaretDownMinor
});

function Button(_ref2) {
  var id = _ref2.id,
      children = _ref2.children,
      url = _ref2.url,
      disabled = _ref2.disabled,
      external = _ref2.external,
      download = _ref2.download,
      submit = _ref2.submit,
      loading = _ref2.loading,
      pressed = _ref2.pressed,
      accessibilityLabel = _ref2.accessibilityLabel,
      role = _ref2.role,
      ariaControls = _ref2.ariaControls,
      ariaExpanded = _ref2.ariaExpanded,
      ariaDescribedBy = _ref2.ariaDescribedBy,
      onClick = _ref2.onClick,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onKeyDown = _ref2.onKeyDown,
      onKeyPress = _ref2.onKeyPress,
      onKeyUp = _ref2.onKeyUp,
      onMouseEnter = _ref2.onMouseEnter,
      onTouchStart = _ref2.onTouchStart,
      icon = _ref2.icon,
      primary = _ref2.primary,
      outline = _ref2.outline,
      destructive = _ref2.destructive,
      disclosure = _ref2.disclosure,
      plain = _ref2.plain,
      monochrome = _ref2.monochrome,
      removeUnderline = _ref2.removeUnderline,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? DEFAULT_SIZE : _ref2$size,
      textAlign = _ref2.textAlign,
      fullWidth = _ref2.fullWidth,
      connectedDisclosure = _ref2.connectedDisclosure;
  var i18n = useI18n();
  var isDisabled = disabled || loading;
  var className = classNames(styles.Button, primary && styles.primary, outline && styles.outline, destructive && styles.destructive, isDisabled && styles.disabled, loading && styles.loading, plain && styles.plain, pressed && !disabled && !url && styles.pressed, monochrome && styles.monochrome, size && size !== DEFAULT_SIZE && styles[variationName('size', size)], textAlign && styles[variationName('textAlign', textAlign)], fullWidth && styles.fullWidth, icon && children == null && styles.iconOnly, connectedDisclosure && styles.connectedDisclosure, removeUnderline && styles.removeUnderline);
  var disclosureMarkup = disclosure ? /*#__PURE__*/React$1.createElement("span", {
    className: styles.Icon
  }, /*#__PURE__*/React$1.createElement("div", {
    className: classNames(styles.DisclosureIcon, loading && styles.hidden)
  }, /*#__PURE__*/React$1.createElement(Icon$1, {
    source: loading ? 'placeholder' : getDisclosureIconSource(disclosure)
  }))) : null;
  var iconSource = isIconSource(icon) ? /*#__PURE__*/React$1.createElement(Icon$1, {
    source: loading ? 'placeholder' : icon
  }) : icon;
  var iconMarkup = iconSource ? /*#__PURE__*/React$1.createElement("span", {
    className: classNames(styles.Icon, loading && styles.hidden)
  }, iconSource) : null;
  var childMarkup = children ? /*#__PURE__*/React$1.createElement("span", {
    className: classNames(styles.Text, removeUnderline && styles.removeUnderline)
  }, children) : null;
  var spinnerSVGMarkup = loading ? /*#__PURE__*/React$1.createElement("span", {
    className: styles.Spinner
  }, /*#__PURE__*/React$1.createElement(Spinner$1, {
    size: "small",
    accessibilityLabel: i18n.translate('Polaris.Button.spinnerAccessibilityLabel')
  })) : null;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      disclosureActive = _useState2[0],
      setDisclosureActive = _useState2[1];

  var toggleDisclosureActive = useCallback(function () {
    setDisclosureActive(function (disclosureActive) {
      return !disclosureActive;
    });
  }, []);
  var connectedDisclosureMarkup;

  if (connectedDisclosure) {
    var connectedDisclosureClassName = classNames(styles.Button, primary && styles.primary, outline && styles.outline, size && size !== DEFAULT_SIZE && styles[variationName('size', size)], textAlign && styles[variationName('textAlign', textAlign)], destructive && styles.destructive, connectedDisclosure.disabled && styles.disabled, styles.iconOnly, styles.ConnectedDisclosure, monochrome && styles.monochrome);
    var defaultLabel = i18n.translate('Polaris.Button.connectedDisclosureAccessibilityLabel');
    var _disabled = connectedDisclosure.disabled,
        _connectedDisclosure$ = connectedDisclosure.accessibilityLabel,
        disclosureLabel = _connectedDisclosure$ === void 0 ? defaultLabel : _connectedDisclosure$;
    var connectedDisclosureActivator = /*#__PURE__*/React$1.createElement("button", {
      type: "button",
      className: connectedDisclosureClassName,
      disabled: _disabled,
      "aria-label": disclosureLabel,
      "aria-describedby": ariaDescribedBy,
      onClick: toggleDisclosureActive,
      onMouseUp: handleMouseUpByBlurring
    }, /*#__PURE__*/React$1.createElement("span", {
      className: styles.Icon
    }, _ref));
    connectedDisclosureMarkup = /*#__PURE__*/React$1.createElement(Popover$1, {
      active: disclosureActive,
      onClose: toggleDisclosureActive,
      activator: connectedDisclosureActivator,
      preferredAlignment: "right"
    }, /*#__PURE__*/React$1.createElement(ActionList$1, {
      items: connectedDisclosure.actions,
      onActionAnyItem: toggleDisclosureActive
    }));
  }

  var commonProps = {
    id: id,
    className: className,
    accessibilityLabel: accessibilityLabel,
    ariaDescribedBy: ariaDescribedBy,
    role: role,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseUp: handleMouseUpByBlurring,
    onMouseEnter: onMouseEnter,
    onTouchStart: onTouchStart
  };
  var linkProps = {
    url: url,
    external: external,
    download: download
  };
  var actionProps = {
    submit: submit,
    disabled: isDisabled,
    loading: loading,
    ariaControls: ariaControls,
    ariaExpanded: ariaExpanded,
    pressed: pressed,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onKeyPress: onKeyPress
  };
  var buttonMarkup = /*#__PURE__*/React$1.createElement(UnstyledButton$1, Object.assign({}, commonProps, linkProps, actionProps), /*#__PURE__*/React$1.createElement("span", {
    className: styles.Content
  }, spinnerSVGMarkup, iconMarkup, childMarkup, disclosureMarkup));
  return connectedDisclosureMarkup ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.ConnectedDisclosureWrapper
  }, buttonMarkup, connectedDisclosureMarkup) : buttonMarkup;
}

function isIconSource(x) {
  return typeof x === 'string' || _typeof(x) === 'object' && x.body || typeof x === 'function';
}

function getDisclosureIconSource(disclosure) {
  if (disclosure === 'select') {
    return SelectMinor;
  }

  return disclosure === 'up' ? CaretUpMinor : CaretDownMinor;
}

export { Button };